module.exports = __webpack_public_path__ + "assets/images/quote-left-white.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/quote-left-white.png
 ** module id = 28
 ** module chunks = 0
 **/